import React, { useState, useEffect } from "react";
import PaymentAccountSelector from "../Selector/PaymentAccountSelector";
import { fetchAccounts } from "../../store/Slices/AccountSlice";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import { useDispatch } from "react-redux";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import AuthBtn from "../Buttons/AuthBtn";
import ExpenseTypeSelector from "../Selector/ExpenseTypeSelector";
import AuthTextArea from "../Input/AuthTextArea";
import { fetchExpenses } from "../../store/Slices/ExpenseSlice";
import { UpdateExpenseApi } from "../../ApiRequests";
import { resolveExpenseTypeFromRow } from "../../utils/ExpenseConverter";
import { fetchExpenseTypes } from "../../store/Slices/ExpenseTypeSlice";
import { useSelector } from "react-redux";
import { toLocalYmd } from "../../utils/dateTime";

const EditExpenseModal = ({ open, setOpen, selectedExpense }) => {
  const dispatch = useDispatch();
  const ExpenseTypes = useSelector((state) => state.ExpenseTypes);

  const [amount, setAmount] = useState("");
  const [desc, setDesc] = useState("");
  const [curDate, setCurDate] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedAccount, setSelectedAccount] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      dispatch(fetchAccounts());
      dispatch(fetchExpenseTypes());
    }
  }, [open, dispatch]);

  useEffect(() => {
    if (selectedExpense) {
      setAmount(selectedExpense.expense?.toString() || "");
      setDesc(selectedExpense.desc || "");
      setCurDate(
        selectedExpense.date
          ? toLocalYmd(selectedExpense.date)
          : toLocalYmd()
      );
      const types = Array.isArray(ExpenseTypes.data) ? ExpenseTypes.data : [];
      setSelectedType(resolveExpenseTypeFromRow(selectedExpense, types) || "");
      const acc = selectedExpense.accountId;
      setSelectedAccount(acc && typeof acc === "object" ? acc : "");
    }
  }, [selectedExpense, ExpenseTypes.data]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!amount || isNaN(amount)) {
      WarningToast("Enter a valid Amount");
    } else if (!desc) {
      WarningToast("Enter a valid Description");
    } else if (!curDate) {
      WarningToast("Select a valid Date");
    } else if (!selectedType?._id) {
      WarningToast("Select Expense Type");
    } else if (!selectedAccount?._id) {
      WarningToast("Select account to pay from");
    } else {
      const payload = {
        expenseTypeId: selectedType._id,
        desc,
        expense: Number(amount),
        // Send YYYY-MM-DD like AddExpense — backend parses with new Date(date)
        date: curDate,
        accountId: selectedAccount._id,
        branchId: selectedExpense.branchId?._id || selectedExpense.branchId,
      };

      try {
        const response = await UpdateExpenseApi(selectedExpense._id, payload);
        if (response.data.success) {
          SuccessToast("Expense updated successfully");
          dispatch(fetchExpenses());
          dispatch(fetchAccounts());
          setOpen(false);
        } else {
          ErrorToast(response.data.error?.msg || "Update failed");
        }
      } catch (err) {
        console.error(err);
        ErrorToast(err.response.data.error.msg);
        ErrorToast("Failed to update expense");
      }
    }

    setLoading(false);
  };

  return (
    <CustomModal open={open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Edit Expense
        </h1>
        <div className="flex gap-4 max696:flex-col px-10 max696:max-h-[70vh] max696:overflow-y-auto">
          <div className="flex flex-col gap-y-4">
            <ExpenseTypeSelector
              selectedType={selectedType}
              setSelectedType={setSelectedType}
            />
            <PaymentAccountSelector
              label="Pay from account"
              selectedAccount={selectedAccount}
              setSelectedAccount={setSelectedAccount}
            />
            <AuthTextArea
              label="Description"
              placeholder="Enter Description"
              Value={desc}
              setValue={setDesc}
            />
            <AuthInput
              label="Date"
              placeholder="Select Date"
              Type="date"
              Value={curDate}
              setValue={setCurDate}
            />
            <AuthInput
              label="Amount"
              placeholder="Enter Amount"
              Type="number"
              Value={amount}
              setValue={setAmount}
            />
          </div>
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Update"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default EditExpenseModal;
